<template>
  <div class="footer_div">
    footer
  </div>
</template>

<script>
export default {
  name: "FooterComponent"
}
</script>

<style scoped>
.footer_div{
  width: 100%;
  height: 50px;
  text-align: center;
}
</style>